// 硬编码文件

import { isProduction } from '../config'


// 专栏是否为互动模式
export function isInteractiveChannel(channelId) {
  // 测试环境和线上的互动模式专栏的 id
  let lectureChannelId = 656664
  if (!isProduction) {
    lectureChannelId = 555001
  }
  return lectureChannelId === channelId
}

// 课程是否为互动模式
export function isInteractiveLecture(lectureId) {
  const productLectureIds = [
    14536375,
    14536397,
    14536426,
    14536434,
    14536441
  ]
  // dbg
  const dbgLectureIds = [
    13334234,
    13334235,
    13334236,
    13334237,
    13334238
  ]
  let interactiveLectureIds = productLectureIds
  if (!isProduction) {
    interactiveLectureIds = dbgLectureIds
  }
  return interactiveLectureIds.indexOf(lectureId) > -1
}



// WEBPACK FOOTER //
// ./src/utils/hardcode.js